"use strict";exports.IMAGE_SIZE={SMALL:"12px",MEDIUM:"20px",LARGE:"26px"},exports.UPDATE_TIME=3e3;
//# sourceMappingURL=constants-Dc3YyiKX.js.map
